import React from 'react';
import InnerComponent from '@Components/Login';

const Login = () => (
  <div>
    <InnerComponent />
  </div>
);
export default Login;
